import { render } from "./Presentation.vue?vue&type=template&id=22ad9d6c&scoped=true"
import script from "./Presentation.vue?vue&type=script&lang=js"
export * from "./Presentation.vue?vue&type=script&lang=js"

import "./Presentation.vue?vue&type=style&index=0&id=22ad9d6c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ad9d6c"]])

export default __exports__